import { FC } from 'react';

import { ProductDto } from '@app/types/product.type';
import { useTranslation } from '@app/app/i18n';
import { analytics } from '@app/app/analytics';
import { PlatformName } from '@app/app/analytics/types';
import { DiamondIcon } from '@app/components/ui/icons';

type AiTokensCardCompactProps = {
  product?: ProductDto;
  onSelectProduct: (product: ProductDto) => void;
  isLoading: boolean;
};

export const AiTokensCardCompact: FC<AiTokensCardCompactProps> = ({
  product,
  onSelectProduct,
  isLoading,
}) => {
  const { t } = useTranslation('pricing');

  if (isLoading) {
    return (
      <div className="animate-pulse">
        <div className="h-20 bg-gray-200 rounded mb-4" />
        <div className="h-12 bg-gray-200 rounded mb-4" />
        <div className="h-32 bg-gray-200 rounded" />
      </div>
    );
  }

  if (!product) {
    return null;
  }

  const handleBuyNow = () => {
    analytics.emitEvent('click_plan', {
      [PlatformName.GTM]: {
        plan: 'ai_tokens',
      },
    });
    onSelectProduct(product);
  };

  return (
    <div className="flex flex-col gap-4 h-full">
      {/* Верхняя секция - покупка токенов */}
      <div className="border border-solid border-general_MI_50 rounded-lg p-6 bg-general_background_MIII_400_dark grow">
        <div className="flex items-center justify-between mb-6">
          {/* Левая часть - количество токенов */}
          <div className="flex items-center gap-2">
            <span className="text-3xl font-bold text-white">{product.included_ai_token_count}</span>
            <DiamondIcon className="w-6 h-6 text-general_MI_50" />
            <span className="text-3xl font-inter font_ds_title_title_title_24 text-white">
              AI tokens
            </span>
          </div>

          {/* Правая часть - цена */}
          <div className="flex flex-col items-end">
            <div className="text-3xl font-bold text-white">
              {product.price.currency_sign} {product.price.amount}
            </div>
            <div className="text-sm text-general_text_MII_secondary_i mt-1">
              {t('aiTokensCard.oneTimePayment')}
            </div>
          </div>
        </div>

        {/* Кнопка покупки */}
        <div className="flex justify-center mb-3">
          <button
            onClick={handleBuyNow}
            className="w-[358px] h-10 rounded-lg flex items-center justify-center gap-2 bg-general_MI_500_default text-white font-semibold hover:bg-general_MI_600_hover transition-colors"
          >
            {t('aiTokensCard.buyNowButton')}
          </button>
        </div>

        {/* Disclaimer */}
        <p className="text-sm text-general_text_MII_secondary_i text-center">
          {t('aiTokensCard.noCommitment')}
        </p>
      </div>

      {/* Нижняя секция - потребление токенов */}
      <div className="border border-dashed border-main_green rounded-2xl p-6 bg-general_background_MIII_400_dark grow">
        {/* Заголовок */}
        <div className="flex items-center gap-2 mb-4">
          <div className="w-5 h-5 rounded-full bg-main_green flex items-center justify-center">
            <span className="text-white text-xs font-bold">i</span>
          </div>
          <h3 className="text-lg font-bold text-white">
            {t('aiTokensCard.estimatedTokenConsumption')}
          </h3>
        </div>

        {/* Список потребления */}
        <div className="space-y-3">
          <div className="flex items-center gap-3">
            <span className="text-main_green text-lg">✓</span>
            <span
              className="text-general_text_MII_default"
              dangerouslySetInnerHTML={{ __html: t('aiTokensCard.imageGeneration') }}
            />
          </div>
          {/* <div className="flex items-center gap-3">
            <span className="text-main_green text-lg">✓</span>
            <span
              className="text-general_text_MII_default"
              dangerouslySetInnerHTML={{ __html: t('aiTokensCard.webSearch') }}
            />
          </div> */}
          {/* <div className="flex items-center gap-3">
            <span className="text-main_green text-lg">✓</span>
            <span
              className="text-general_text_MII_default"
              dangerouslySetInnerHTML={{ __html: t('aiTokensCard.infographicGeneration') }}
            />
          </div> */}
        </div>
      </div>
    </div>
  );
};
